import * as React from "react";
import {
	Dialog,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from "@mui/material/";

export default function RedirectDialog({ show = false, timer = 10 }) {
	return (
		<React.Fragment>
			<Dialog
				open={show}
				aria-labelledby="completed-dialog"
				aria-describedby="completed-dialog-d"
			>
				<DialogTitle id="completed-dialog">Finish Later?</DialogTitle>
				<DialogContent>
					<DialogContentText sx={{ fontWeight: "bold", mb: 2 }}>
						We have sent you an email containing a link to your
						quiz.
					</DialogContentText>
					<DialogContentText id="finish-later-dialog-d">
						You will now be redirected to the login screen in{" "}
						{timer}.
					</DialogContentText>
				</DialogContent>
			</Dialog>
		</React.Fragment>
	);
}
